import { useEffect, useState } from "react";

/**
 * The current time in ms, re-read every `intervalMs`, so text like "9 min"
 * keeps counting without the data behind it changing.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
